import React from 'react';
const CardNumber = ({label, name, type= "text", value, onChange, error }) => (
    <div className="row form-group">
         <label  className="col-sm-4">{label}</label>
         <div className="col-sm-8" >
            <input type = {type} name={name}
              value={value} onChange={onChange}
              className={(error ? 'form-control highlight-error' : 'form-control')}
            />
            {error &&  <p className="text-danger">{error}</p>}
         </div>
    </div>
);

export default CardNumber;



// WEBPACK FOOTER //
// ./src/components/prepaidCard/CardNumber.js